import React, { useEffect, useState } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import httpHelper from 'utils/http-helper';
import URL_CONSTANTS from 'constants/url-constants';
import Select from '../../../components/ui/Select';
import { Method_TYPE } from 'utils/http-helper';

const DistrictModal = ({ isModalOpen, setIsModalOpen, selectedPoint, getDistrictDetails, districtOptions }) => {
    const [formData, setFormData] = useState({
        districtName: '',
        state :'TNN'
    });

    const [editId, setEditId] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [stateOptions, setStateOptions] = useState([
        { value: 'TNN', label: 'TNN' },
        { value: 'TNS', label: 'TNS' },
    ])

    const [stateVal,SelectedStateVal] = useState('TNN');

    // Populate data in edit mode
    useEffect(() => {
        if (selectedPoint?.length > 0 && districtOptions?.length > 0) {
            const selectedDistrict = districtOptions.find(
                (sec) => sec.value === selectedPoint[0]?.value
            );

            //console.log("selectedSector", selectedDistrict)
            setFormData({
                districtName: selectedDistrict?.label || '',
                state: selectedDistrict?.state || 'TNN',
            });

            setEditId(selectedPoint[0]?.value);
        }
    }, [selectedPoint, districtOptions]);

    //console.log("formData", formData)
    const handleCancel = () => {
        setIsModalOpen(false);
        setFormData({ districtName: '' });
        setEditId('');
    };

    const handleInputChange = (field, event) => {
        const value = event?.target?.value ?? event;
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const onStateChange = (stateVal) => {
        SelectedStateVal(stateVal);
         formData.state = stateVal
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            if (selectedPoint?.length > 0) {
                await httpHelper(`${URL_CONSTANTS.EDIT_DISTRICT}/${editId}`, Method_TYPE.PUT, formData);
            } else {
                await httpHelper(`${URL_CONSTANTS.ADD_DISTRICT}`, Method_TYPE.POST, formData);
            }
            formData.state = 'TNN'
            SelectedStateVal('TNN')
            getDistrictDetails();
            handleCancel();
        } catch (error) {
            console.error('Error saving District:', error);
        } finally {
            setIsLoading(false);
        }
    };

    if (!isModalOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-card rounded-lg border border-border w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                {/* Header */}
                <div className="flex items-center justify-between p-6 border-b border-border">
                    <div>
                        <h2 className="font-heading font-semibold text-lg text-foreground">
                            {selectedPoint?.length > 0 ? 'Edit District' : 'Add District'}
                        </h2>
                        <p className="text-sm text-muted-foreground">
                            Configure district requirements and details
                        </p>
                    </div>
                    <Button variant="ghost" size="sm" onClick={handleCancel} iconName="X" />
                </div>

                {/* Form */}
                <form onSubmit={handleSubmit} className="p-6 space-y-6">
                    <div className="space-y-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <Input
                                label="District" 
                                name="districtName"
                                value={formData.districtName}
                                onChange={(value) => handleInputChange('districtName', value)}
                                required
                            />

                             <Select
                                label="State"
                                options={stateOptions}
                                name="state"
                                value={stateVal}
                                onChange={(value) => onStateChange( value)}
                                required
                            />
                        </div>
                    </div>
                    <div className="flex items-center justify-end space-x-3 pt-4 border-t border-border">
                        <Button type="button" variant="outline" onClick={handleCancel} disabled={isLoading}>
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            variant="default"
                            loading={isLoading}
                            iconName="Save"
                            iconPosition="left"
                        >
                            {selectedPoint?.length > 0 ? 'Update District' : 'Create District'}
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default DistrictModal;
